import ratings from "./ratings.component";
import ratingsUrls from "./ratings.urls";
import RatingsTransforms from "./ratings.transforms";

const ratingsModule = angular
  .module("app.components.ratings", [])
  .component("ratingsPage", ratings)
  .service("RatingsTransforms", RatingsTransforms)
  .config(ratingsUrls);

export default ratingsModule;



// WEBPACK FOOTER //
// ./src/pages/ratings/ratings.module.js